@use '@lib/assets/styles/main.scss' as *;

.root {
  padding-bottom: 24px;
  min-width: 0;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  border-top: 1px solid $gray100;
  border-bottom: 1px solid $gray100;
  padding: 12px 16px;
  @include responsive($md1) {
    gap: 16px;
  }
  @include responsive(null, $md1) {
    gap: 12px;
  }
}

.actionsRow {
  display: flex;
  align-items: center;
  @include responsive($md1) {
    gap: 16px;
  }
  @include responsive(null, $md1) {
    gap: 8px;
  }
}

.viewerWrap {
  height: 60vh;
  overflow-x: auto;
}

.viewerWrapFull {
  height: Calc(100vh - 72px - 66px - 24px - 24px - 24px);
  overflow-x: auto;
}

.fullscreenExitBtn {
  top: 24px;
  position: fixed;
  right: 24px;
  z-index: 1;
}

.pageNumber {
  position: relative;
}
